import { useContext } from 'react';

import CreateEditSchemaModalContext, {
  ModalStep,
} from '@atom/components/common/createEditSchemaModal/CreateEditSchemaModalContext';
import { Stepper } from '@atom/mui';
import {
  SchemaBudgetType,
  StartEndReadingOption,
  StockBasedOption,
} from '@atom/types/schema';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { getStepIndex } from './createEditSchemaUtilities';

import classes from './createEditSchemaModal.module.css';

const { StepLabel, Step } = Stepper;

const StepperSidebar = () => {
  const {
    activeStep,
    STEPS_ARRAY,
    name,
    isMaterial,
    stockBasedOption,
    startEndReadingOption,
    costType,
    rate,
    unit,
  } = useContext(CreateEditSchemaModalContext);

  const activeStepIndex = getStepIndex(activeStep, STEPS_ARRAY);

  const getCostTrackingSubtext = () => {
    const stockEnabled =
      stockBasedOption === StockBasedOption.STOCK_BASED ||
      stockBasedOption === StockBasedOption.STOCK_BASED_OPTIONAL;
    const startEndEnabled =
      startEndReadingOption === StartEndReadingOption.START_END_READING ||
      startEndReadingOption ===
        StartEndReadingOption.START_END_READING_OPTIONAL;

    switch (true) {
      case !isMaterial:
        return 'Disabled';
      case stockEnabled:
        return 'Stock-based Inventory';
      case startEndEnabled:
        return 'Start and End Readings';
      default:
        return 'Enabled';
    }
  };

  const getCostAndUnitSubtext = () => {
    switch (costType) {
      case SchemaBudgetType.VARIABLE:
        return 'Variable';
      case SchemaBudgetType.VARIABLE_COST:
        return !isNilOrEmpty(unit) ? (
          <span className={classes.costSubtext}>{unit}</span>
        ) : (
          'Variable Cost'
        );
      case SchemaBudgetType.FIXED:
        return !isNilOrEmpty(rate) && !isNilOrEmpty(unit) ? (
          <span
            className={classes.costSubtext}
          >{`${numberToLocaleString(rate)} / ${unit}`}</span>
        ) : (
          ''
        );
      default:
        return '';
    }
  };

  const getStepSubtext = (step: ModalStep) => {
    switch (step) {
      case ModalStep.BASIC_DETAILS:
        return name || 'New Asset Type';
      case ModalStep.COST_TRACKING:
        return getCostTrackingSubtext();
      case ModalStep.COST_AND_UNIT:
        return getCostAndUnitSubtext();
      default:
        return '';
    }
  };

  return (
    <div className={classes.stepperContainer}>
      <Stepper activeStep={activeStepIndex} orientation="vertical">
        {STEPS_ARRAY.map(step => {
          const subtext = getStepSubtext(step.value);

          return (
            <Step key={step.title}>
              <StepLabel>
                <>
                  <div>{step.title}</div>
                  {subtext && (
                    <div className={classes.stepSubtext}>{subtext}</div>
                  )}
                </>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default StepperSidebar;
